<label [for]="id">{{ label }}</label>
<p *ngIf="subtitle" class="field-subtitle">{{ subtitle }}</p>
<div class="input-wrap">
  <input
    [ngClass]="{'invalid': invalidPass}" 
    [id]="id"  
    [type]="type"
    [placeholder]="placeholder ?? label"
    [value]="value"
    [disabled]="disabled"
    [class.large]="large"
    [class.validation]="validation"
    [class.pristine]="pristine"
    [class.dirty]="dirty"
    [class.touched]="touched"
    [class.invalid]="invalid"
    [class.valid]="valid"
    (dateChange)="change($event.target.value)"
    [max]="max"
    [min]="min"
    [textMask]="mask"
    [matDatepicker]="picker"
    (blur)="onTouched()" />
  <mat-datepicker-toggle 
    matSuffix [for]="picker" 
    [disableRipple]="true" 
    >
    <span matDatepickerToggleIcon class="icon-calendar " style="font-size:20px"></span>
  </mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</div>
<div class="messages" *ngIf="showMessages">
  <ng-content selector="app-form-error"></ng-content>
</div>
